// updates the search parameters in the URL and return the new search params object
export const updateSearchParams = (newParams, preserveCurrentParams = true) => {
  const startingParams = preserveCurrentParams ? window.location.search : ''

  // console.log('newParams',newParams);

  const newSearchParams = new URLSearchParams(startingParams)
  Object.keys(newParams).forEach((key) =>
    newSearchParams.set(key, newParams[key])
  )

  const paramsString = newSearchParams.toString()
  if (window.history.pushState) {
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${paramsString}`
    window.history.pushState({ path: newUrl }, '', newUrl)
  }

  return newSearchParams
}
